import React from "react"

export default function FAQPage() {
  return <h1>FAQ Page</h1>
}
